import React, { useState } from 'react';

import NoticesAlert from '../../../features/notices/components/noticesAlert';
import MobileHeader from './components/mobile-header';
import MobileNotificationsSidebar from './components/mobile-notifications-sidebar';
import MobileSidebar from './components/mobile-sidebar';

export type MobileLayoutProps = {
  children?: React.ReactNode;
};

const MobileLayout = ({ children }: MobileLayoutProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [areNotificationsOpen, setAreNotificationsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleNotifications = () => {
    setAreNotificationsOpen(!areNotificationsOpen);
  };

  return (
    <>
      <NoticesAlert />
      <MobileHeader onMenuClick={toggleSidebar} onNotificationsClick={toggleNotifications} />
      <MobileSidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
      <MobileNotificationsSidebar isOpen={areNotificationsOpen} onClose={toggleNotifications} />
      <div style={{ marginTop: 64, boxSizing: 'border-box', padding: '1rem', backgroundColor: 'var(--bg-color)' }}>
        {children}
      </div>
    </>
  );
};

export default MobileLayout;
